/**
 * Ellenőrzi, hogy az app verziója megváltozott-e (Docker restart)
 * Ha igen, törli a cookie-kat és frissíti a verziót
 */

// Build ID/verzió - ezt a Docker build során lehet generálni
// Vagy egyszerűen a package.json version-t használni
const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION || '1.0.0';
const VERSION_KEY = 'app_version';

export function checkAndClearOnVersionChange() {
    if (typeof window === 'undefined') return; // SSR guard
    
    try {
        const storedVersion = localStorage.getItem(VERSION_KEY);
        
        // Ha nincs tárolt verzió, ez az első látogatás
        if (!storedVersion) {
            localStorage.setItem(VERSION_KEY, APP_VERSION);
            console.log('App version initialized:', APP_VERSION);
            return;
        }
        
        // Ha a verzió megváltozott (Docker restart)
        if (storedVersion !== APP_VERSION) {
            console.warn('App version changed, clearing cookies:', {
                old: storedVersion,
                new: APP_VERSION
            });
            
            // Cookie törlés
            clearAllCookies();
            
            // Verzió frissítése
            localStorage.setItem(VERSION_KEY, APP_VERSION);
            
            // Opcionális: oldal újratöltése
            window.location.reload();
        }
    } catch (error) {
        console.error('Version check failed:', error);
    }
}

function clearAllCookies() {
    document.cookie.split(";").forEach(function(c) { 
        document.cookie = c.replace(/^ +/, "")
                          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    });
    console.log('All cookies cleared due to version change');
}

/**
 * Csak auth cookie-k törlése verzióváltáskor
 */
export function clearAuthCookiesOnVersionChange() {
    if (typeof window === 'undefined') return;
    
    try {
        const storedVersion = localStorage.getItem(VERSION_KEY);
        
        if (!storedVersion) {
            localStorage.setItem(VERSION_KEY, APP_VERSION);
            return;
        }
        
        if (storedVersion !== APP_VERSION) {
            console.warn('App version changed, clearing auth cookies');
            
            const authCookies = [
                'next-auth.session-token',
                '__Secure-next-auth.session-token',
                'next-auth.csrf-token',
                '__Host-next-auth.csrf-token',
                'token'
            ];
            
            authCookies.forEach(name => {
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
            });
            
            localStorage.setItem(VERSION_KEY, APP_VERSION);
        }
    } catch (error) {
        console.error('Auth cookie clear failed:', error);
    }
}
